"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = Table;
var React = _interopRequireWildcard(require("react"));
var _hooks = require("./hooks");
var _StaticTable = require("./StaticTable");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * Table
 * @param {React.ComponentType} Row - React.ComponentType<{data: Data, extras?: Extras, sortedKeys?: string[]}>
 * @param {string} className - string
 *
 **/

/**
 * Table
 * @param {React.ComponentType} Row - React.ComponentType<{data: Data, extras?: Extras, sortedKeys?: string[]}>
 * @param {string} className - string
 *
 */
function Table(props) {
  const {
    // eslint-disable-next-line unused-imports/no-unused-vars
    className,
    // eslint-disable-next-line unused-imports/no-unused-vars
    classNames,
    // eslint-disable-next-line unused-imports/no-unused-vars
    TableRow,
    entries,
    // eslint-disable-next-line unused-imports/no-unused-vars
    extras,
    // eslint-disable-next-line unused-imports/no-unused-vars
    headers,
    // eslint-disable-next-line unused-imports/no-unused-vars
    showHeader = true,
    // eslint-disable-next-line unused-imports/no-unused-vars
    tableHeaderClassName,
    sortable = true,
    defaultSortKey,
    defaultSortDirection = 'original',
    onSort,
    enableInternalSorting,
    // eslint-disable-next-line unused-imports/no-unused-vars
    isLoading,
    idName = 'id',
    // eslint-disable-next-line unused-imports/no-unused-vars
    emptyText
  } = props;

  /**
   *
   */
  // eslint-disable-next-line unused-imports/no-unused-vars
  const {
    sortedEntries,
    sortedKeys,
    ...sortableProps
  } = (0, _hooks.useSortableEntries)(entries, idName, {
    defaultSortKey,
    defaultSortDirection,
    onSort,
    enableInternalSorting
  });
  return /*#__PURE__*/React.createElement(_StaticTable.StaticTable, _extends({}, props, sortableProps, {
    sortable: sortable,
    entries: entries,
    rowKeys: sortedKeys
  }));
}